import React, {Component} from "react"
import PropTypes from "prop-types";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Collapse from "@material-ui/core/Collapse";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Divider from "@material-ui/core/Divider";
import {withStyles} from "@material-ui/core/styles";
import dataKved from "../../data/dataKVED_mod.json";
import MainList from "./MainList";
import "../ListMain/Test.css"
import Row from "react-bootstrap/Row";
import {Col} from "react-bootstrap";
import Lottie from "lottie-react";
import groovyWalkAnimation from "../../Image/business-team.json";
import finance from "../../Image/finances-management.json";
import finance0 from "../../Image/financial-transactions.json";
import dataPou from "../../data/dataPou.json";


const data = dataKved;

const dataSpisok = [].concat(dataPou)
    .sort((a, b) => a.pou_nazva_minust > b.pou_nazva_minust ? 1 : -1);
const styles = theme => ({
    root: {
        width: "100%",
        // maxWidth: 360,
        background: theme.palette.background.paper
    },
    nested: {
        paddingLeft: theme.spacing.unit * 4
    }
});

function getItems() {
//   //  console.log(json)

    const filterKved = () => {
        const dataPouFiltred = dataSpisok.map((reviewObj) => {
            return (
                reviewObj.idkved.slice(0, 2))
        })
        const uniqueNames = Array.from(new Set(dataPouFiltred));
        const filtered = filterData(data[0].items, 'idkved', uniqueNames);
       //  console.log(filtered);

        function filterData(data, prop, values) {

            return data.filter(function (item) {
                return ~values.indexOf(item[prop]); // ~ returns 0 if indexOf returns -1
            });
        }

       //  console.log(uniqueNames);
       //  console.log(filtered);
    }
    return {
        list:
        data
    };
}


class Test0 extends Component {
    constructor() {
        super();
        this.state = {
            idkved: [],
            kvednazva: [],
            show: true,
            search: null,
            spisok: getItems(),
            spisok0: [],
            spisok1: [],
            spisok2: []
        };

    }
    handleClick = e => {
        this.setState({
            [e]: !this.state[e]
        });
      // //  console.log(this.state)
    };
    handleClick0 = e => {
        this.setState({
            idkved: e,
            show: false,
        });
       ////  console.log(e)
       ////  console.log(this.state.show)
    };
    searchSpace = (event) => {
        let keyword = event.target.value !== "" ? event.target.value : null
       //  console.log(keyword)
        this.setState({
            search: keyword
        })
    }
    searchpou = (e) => {
        const test = getItems();
        const data0 = data;
      // //  console.log(test.list[0].items)

        let filtred = test.list[0].items.filter((data) => {
                if (this.state.search === null)
                    return data0
                else if (data.kvednazva.toLowerCase().includes(this.state.search.toLowerCase())) {
             //      //  console.log(data.kvednazva)
              //     //  console.log(this.state.search)
                    return data
                }
            }
        )

        this.setState({
            spisok: {
                list: [{
                    items:
                    filtred
                }]
            }
        })
      // //  console.log(filtred);
      // //  console.log(this.state.spisok);
    }
    filterKved = () => {
        const dataPouFiltred = dataSpisok.map((reviewObj) => {
            return (
                reviewObj.idkved.slice(0, 2))
        })
        const uniqueNames = Array.from(new Set(dataPouFiltred));
        const filtered = filterData(data[0].items, 'idkved', uniqueNames);
        function filterData(data, prop, values) {
            return data.filter(function (item) {
                return ~values.indexOf(item[prop]); // ~ returns 0 if indexOf returns -1
            });
        }
       ////  console.log(filtered);
        return filtered
    }
    filterKvedIn = () => {
        const dataPouFiltred =dataSpisok.map((reviewObj) => {
            return (
                reviewObj.idkved)
        })
        const uniqueNamesIn = Array.from(new Set(dataPouFiltred));
        const indata=data[0].items.map((tp)=>{
            return( tp.subitems)
        })
         const invalue=indata.map((top)=>{
            return( top.map((tip)=>{
                return( tip)
            }))
             })
        const newArr = Array.prototype.concat(...invalue);

        const filteredIn = filterData(newArr, 'idkved', uniqueNamesIn);
        function filterData(data, prop, values) {
            return data.filter(function (item) {
                return ~values.indexOf(item[prop]); // ~ returns 0 if indexOf returns -1
            });
        }
       ////  console.log(uniqueNamesIn)
       // //  console.log( newArr)
       //  //  console.log(filteredIn)
        this.setState({
            spisok2: newArr
        });
             return filteredIn

        }



    componentDidMount() {
       ////  console.log(this.state.show)
        this.filterKved()
        this.setState({
            spisok0: this.filterKved()
        });
        this.filterKvedIn()
        this.setState({
            spisok1:  this.filterKvedIn()
        });

    }


    render() {
        const choice = this.state.show;
        const items = this.state.spisok;
        const items0 = this.state.spisok0;
        //console.log(items0)
        const items1 = this.state.spisok1;
      //  const test = this.state.spisok2
      // //  console.log(items1)
      // //  console.log(test)
        const {classes} = this.props;

        return (
            <>
                {choice ?
                    <Row>
                        <Col md={9}>
                            <div className="bodyall">
                                <div style={{
                                    marginTop:"-5%"
                                }}>
                                    <div style={{
                                        backgroundColor: "black",
                                        clipPath: "polygon(50% 0%, 0% 100%, 50% 100%)",
                                        width: "4rem",
                                        marginLeft: "1rem",

                                    }}>""
                                    </div>
                                    <div

                                        className="cart-company-lg_pagesearch ">За видом діяльності
                                    </div>
                                    <Row className="col-auto flex-grow-1" style={{ display:"none"}}>
                                        <input className="search-form__input form-control" type="text"
                                               placeholder="Введіть критерій"
                                               onChange={(e) => this.searchSpace(e)}/>
                                        <button className="search-form__submit btn btn-warning" onClick={this.searchpou}
                                                style={{
                                                    width: "auto",
                                                    marginTop: "0",
                                                    marginBottom: "0"
                                                }}> Шукати
                                        </button>
                                    </Row>
                                </div>
                                {items.list.map(list => {
                                        return (
                                            <List key={list.id}>
                                                {items0.map(item => {
                                                    let dataNew = item.subitems.map((reviewObj) => {
                                                        return (
                                                            reviewObj.idkved.slice(0, 2))
                                                    })
                                                    let dataPouFiltred = items1.filter((reviewObj) => {
                                                        if (reviewObj.idkved.slice(0, 2) === dataNew[0])
                                                            return (
                                                                reviewObj)
                                                    })
                                                    return (
                                                        <div key={item.id}>
                                                            {item.subitems != null ? (
                                                                <div key={item.id}>
                                                                    <ListItem
                                                                        button
                                                                        key={item.id}
                                                                        onClick={this.handleClick.bind(
                                                                            this,
                                                                            item.kvednazva
                                                                        )}
                                                                    >
                                                                        <ListItemText
                                                                            primary={item.kvednazva}

                                                                        />
                                                                        {this.state[item.kvednazva] ? (
                                                                            <ExpandLess/>
                                                                        ) : (
                                                                            <ExpandMore/>
                                                                        )}
                                                                    </ListItem>
                                                                    <Collapse
                                                                        key={list.items.id}
                                                                        component="li"
                                                                        in={this.state[item.kvednazva]}
                                                                        timeout="auto"
                                                                        unmountOnExit
                                                                    >
                                                                        <List disablePadding>
                                                                            {dataPouFiltred.map(
                                                                                subitem => {
                                                                                    return (
                                                                                        <ListItem
                                                                                            className="choice"
                                                                                            button
                                                                                            onClick={this.handleClick0.bind(
                                                                                                this,
                                                                                                subitem.idkved
                                                                                            )}
                                                                                            key={
                                                                                                subitem.id
                                                                                            }
                                                                                            className={
                                                                                                classes.nested
                                                                                            }
                                                                                        >
                                                                                            <ListItemText
                                                                                                key={
                                                                                                    dataPouFiltred.id
                                                                                                }
                                                                                                primary={
                                                                                                    subitem.kvednazva
                                                                                                }
                                                                                            />
                                                                                        </ListItem>
                                                                                    );
                                                                                }
                                                                            )
                                                                            }
                                                                        </List>
                                                                    </Collapse>{" "}
                                                                </div>
                                                            ) : (
                                                                <ListItem
                                                                    button
                                                                    onClick={this.handleClick.bind(
                                                                        this,
                                                                        item.kvednazva
                                                                    )
                                                                    }
                                                                    key={item.id}
                                                                >
                                                                    <ListItemText
                                                                        primary={item.kvednazva}
                                                                        style={{
                                                                            fontSize:"0.5rem"
                                                                        }}
                                                                    />
                                                                </ListItem>
                                                            )}
                                                        </div>
                                                    );
                                                })
                                                }
                                                <Divider key={list.id} absolute/>
                                            </List>
                                        );
                                    }
                                )
                                }
                            </div>
                        </Col>
                        <Col style={{
                            background: "radial-gradient(464.98px at 50% 50%, #26486F 0%, #122945 100%)"
                        }} md={3}> <Lottie style={{
                            marginTop: "3rem", marginBottom: "3rem"
                        }} className="lottsearch"
                                           animationData={groovyWalkAnimation}/>
                            <Lottie className="lottsearch"
                                    animationData={finance}/>
                            <Lottie style={{
                                marginTop: "3rem", marginBottom: "3rem"
                            }} className="lottsearch"
                                    animationData={finance0}/>
                        </Col>
                    </Row>
                    :
                    <MainList kvdata={this.state.idkved}/>
                }
            </>
        );
    }
}

Test0.propTypes = {
    classes: PropTypes.object.isRequired
};
export default withStyles(styles)(Test0);